import React from 'react';
import copy from 'copy-to-clipboard';
import { Copy, Pencil } from 'lucide-react';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { toast } from '@dashboard/context/ToastContext';
import Link from '@dashboard/components/Link';
import { Button } from '@dashboard/components/ui/button';
import {
  getLinkInBioSharedUrl,
  LINK_IN_BIO_SELLER_VISIT,
  withLinkInBioQuery,
} from '@dashboard/services/getLinkInBioUrl';

export default function YourLink({ savedPublished }: { savedPublished: boolean }) {
  const { seller } = useAuth();
  const shownUrl = getLinkInBioSharedUrl(seller);

  if (!shownUrl) {
    return (
      <span>
        Your link in bio lives at your store URL.{' '}
        <Link to="/settings/domains">Set your store URL</Link>
      </span>
    );
  }

  const onCopy = () => {
    copy(shownUrl);
    toast({ title: 'Link copied', type: 'success' });
  };

  return (
    <span className="flex min-w-0 flex-wrap items-center gap-x-1">
      {savedPublished ? (
        <a
          href={withLinkInBioQuery(shownUrl, LINK_IN_BIO_SELLER_VISIT)}
          target="_blank"
          rel="noopener noreferrer"
          className="min-w-0 truncate text-foreground hover:underline"
        >
          {shownUrl}
        </a>
      ) : (
        <span className="min-w-0 truncate">{shownUrl} · live once you publish</span>
      )}
      <Button type="button" variant="ghost" size="icon-sm" onClick={onCopy} aria-label="Copy link">
        <Copy />
      </Button>
      <Button variant="ghost" size="icon-sm" asChild>
        <Link to="/link-in-bio/settings" aria-label="Edit link">
          <Pencil />
        </Link>
      </Button>
    </span>
  );
}
